import { Drawer, Form, FormInstance, Input, Select, TreeSelect } from "antd"
import { useForm } from 'antd/lib/form/Form';
import { useEffect, useMemo, useRef, useState } from "react";
import type { FormProps } from 'antd';
import { IAccountDetail, IGroupPermission, editUserAccount } from "../../../../api/groupPermission/groupPermissionApi";
import { ITag, IUnitChild } from "../../../../api/selectOptions/selectOptionsApi";
import { filterDuplicateUnitV2, fommatSelectOption } from "../../../../until";
import { IBusiness } from "../../../../api/selectOption/selectOptionsApi";
import LoadingSpin from "../../../../components/LoadingSpin";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import { icon_delelte } from "../../../../components/ExportImgFigma";
import * as fomartUnit from "../../../../services/fomartUnit"
import * as SelectOptionApi from "../../../../api/selectOptions/selectOptionsApi"
import *as unitApi from "../../../../api/unit/unitApi"
import '../style.scss'
import { OptionSelect_V2, TreeSelectCustom } from "../Components/TreeSelectCustom";
import { TreeSelectCustom_V2 } from "../Components/TreeSelectCustom_V2";
import { getListUnitByUserPermission } from "../../../../api/unitByUserPermission";
import { useDispatch, useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import { setUnitByUserPermission } from "../../../../store/slices/UnitByUserPermission";
import useDebounce from "../../../../hook/useDebounce";

interface DrawerProps {
  isOpen: boolean
  infoAccount?: IAccountDetail
  sLUnitChild: IUnitChild[]
  sLBusinessUnit: IBusiness[]
  sLUnitByPermission: any[]
  sLGroupPermission: ITag[]

  sLUnitByPermissionNotFM?: any[]
  onSubmitFormModal?: (iSsuccess: boolean, message?: string) => void;
  closeDrawer: () => void
}
const EditAccount_V3: React.FC<DrawerProps> = ({
  isOpen, infoAccount, sLUnitByPermission, sLGroupPermission, sLUnitByPermissionNotFM, onSubmitFormModal, closeDrawer
}) => {
  const dispatch = useDispatch();
  const { id, unitTemp } = useSelector(selectorInfoUser)

  const [hasInitFirstScope, setHasInitFirstScope] = useState(false);
  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);

  const unitId = Form.useWatch('unitId', form);
  const permission = Form.useWatch('permission', form);

  const [checkloading, setCheckloading] = useState<boolean>(false)

  // const [dataListNationwide, setDataListNationwide] = useState<fomartUnit.OptionSelect_V2[]>([])

  const [valuesUnitList, setValuesUnitList] = useState<number[][]>([]);
  const [unitCounts, setUnitCounts] = useState<number[]>([]); // State lưu số lượng đơn vị cho mỗi nhóm quyền
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const dataListNationwide = useMemo(() => {
    return unitApi.convertNationwideTree(sLUnitByPermissionNotFM ?? []);
  }, [sLUnitByPermissionNotFM]);

  // phạm vi hoạt động
  // const gListNationwide = useDebounce( async () => {
  //   const result = await SelectOptionApi.getListNationwide(unitTemp);
  //   if (result?.status) {
  //     setDataListNationwide(unitApi.convertNationwideTree(result.data))
  //   }
  // },500)


  // disable các id đã chọn
  const getDisabledIdsForIndex = (currentIndex: number) => {
    let disabledIds: number[] = [];
    valuesUnitList.forEach((selectedIds, index) => {
      if (index !== currentIndex) {
        disabledIds = disabledIds.concat(selectedIds);
      }
    });
    return disabledIds;
  };

  const handleGroupPermission = (index: number, value: number) => {

    setSelectedIds(prev => {
      const newIds = [...prev];
      newIds[index] = value;
      return newIds;
    });
    // Lấy giá trị hiện tại của trường 'permission' từ form
    const currentPermissions = form.getFieldValue('permission') || [];

    // Tạo bản sao của currentPermissions
    const updatedPermissions = [...currentPermissions];

    // Cập nhật đúng phần tử tại vị trí index
    updatedPermissions[index] = {
      ...updatedPermissions[index],
      grouppermission: value, // Cập nhật giá trị grouppermission cho đúng index
    };
    // Set lại giá trị cho trường 'permission'
    form.setFieldsValue({ permission: updatedPermissions });

  };


  const handleChangeUnit = (index: number, values: number[]) => {
    const currentPermissions = form.getFieldValue('permission') || [];
    const numberValues = values?.map(item => item);
    const oldList = [...valuesUnitList];
    const newList = oldList.map(arr => [...arr]);
    newList[index] = numberValues;

    for (let j = index + 1; j < newList.length; j++) {
      newList[j] = newList[j].filter(id => !numberValues.includes(id));
    }

    setValuesUnitList(newList);

    const updatedPermissions = currentPermissions.map((item: any, idx: any) => ({
      ...item,
      scopeofoperation: newList[idx] || [],
    }));

    form.setFieldsValue({ permission: updatedPermissions });
  };

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  // const onFinish: FormProps<any>['onFinish'] = async (values) => {
  //   const permissionCustomer = values.permission.map((item: any) => {
  //     let unitId: number[] = []
  //     if (isNaN(item['scopeofoperation'][0])) {
  //       unitId = item['scopeofoperation'].map((item: any) => item.value)
  //     } else {
  //       unitId = item['scopeofoperation']
  //     }
  //     return {
  //       groupPermissionId: item["grouppermission"],
  //       unitId: unitId
  //     };

  //   })

  //   confimSubmit(values.name, values.email, [], values.unitId, values.businessUnitId, values.departmentId, permissionCustomer)
  // }

  const onFinish: FormProps<any>['onFinish'] = async (values) => {
    const permissionCustomer = values.permission.map((item: any) => {
      const scope = item.scopeofoperation || [];

      const unitId = scope.map((x: any) => {
        if (typeof x === 'object') {
          return Number(x.value);
        }

        return Number(x);
      });

      return {
        groupPermissionId: item.grouppermission,
        unitId,
      };
    });

    confimSubmit(
      values.name,
      values.email,
      [],
      values.unitId,
      values.businessUnitId,
      values.departmentId,
      permissionCustomer
    );
  };

  const confimSubmit = async (
    name: string, email: string, parentIds: { id: number, level: number }[], unitId: number, businessUnitId: number, departmentId: number, grouppermission: IGroupPermission[]
  ) => {
    setCheckloading(true)
    const result = await editUserAccount(
      Number(infoAccount?.id), name, undefined, email, undefined, undefined, unitId, businessUnitId, departmentId, grouppermission)
    if (result?.status) {
      setCheckloading(false)
      onSubmitFormModal?.(true, result?.message)

      //kiểm tra trường hợp nếu mà trùng id vs id ng dang chỉnh sửa gọi lại phạm vi hoạt động
      // set cho redux thay vì đang xuất
      if (Number(infoAccount?.id) === Number(id)) {
        const resultUnitPermission = await getListUnitByUserPermission()
        if (result?.status) {
          dispatch(setUnitByUserPermission(resultUnitPermission?.data))
        }
      }
    } else {
      setCheckloading(false)
      onSubmitFormModal?.(false, result?.message)
    }
  }



  // useEffect(() => {
  //   if (dataListNationwide.length === 0) {
  //     gListNationwide()
  //   }
  // }, [dataListNationwide])

  // //rs khi thay ddooir ddonw vij

  const getChildren = (node: any) => {
    return node.children || node.childs || node.units || [];
  };

  const getNodeValue = (node: any) => {
    return Number(node.value ?? node.id);
  };

  const getSelfAndChildIdsByParentId = (tree: any[], parentId: number): number[] => {
    const result: number[] = [];

    const collect = (node: any) => {
      const value = getNodeValue(node);

      if (!Number.isNaN(value)) {
        result.push(value);
      }

      getChildren(node).forEach(collect);
    };

    const dfs = (nodes: any[]): boolean => {
      for (const node of nodes) {
        if (getNodeValue(node) === Number(parentId)) {
          collect(node);
          return true;
        }

        if (dfs(getChildren(node))) {
          return true;
        }
      }

      return false;
    };

    dfs(tree);

    return Array.from(new Set(result));
  };

  useEffect(() => {
    if (isOpen) {
      setHasInitFirstScope(false);

      const defaultUnitId = infoAccount?.unit?.id;
      const defaultScopeIds = defaultUnitId ? getSelfAndChildIdsByParentId(dataListNationwide, Number(defaultUnitId)) : [];

      const permissionTmp = (infoAccount?.unitsByPermissionGroup && infoAccount.unitsByPermissionGroup.length > 0)
        ? infoAccount.unitsByPermissionGroup.map(g => ({
            grouppermission: g.groupPermissionId,
            scopeofoperation: g.units && g.units.length > 0 
              ? g.units.map(u => u.id) 
              : defaultScopeIds,
          }))
        : [{ grouppermission: undefined, scopeofoperation: defaultScopeIds }];

      const valuesUnitListTmp = (infoAccount?.unitsByPermissionGroup && infoAccount.unitsByPermissionGroup.length > 0)
        ? infoAccount.unitsByPermissionGroup.map(g => g.units && g.units.length > 0 
            ? g.units.map(u => u.id) 
            : defaultScopeIds
          )
        : [defaultScopeIds];

      setValuesUnitList(valuesUnitListTmp)

      form.setFieldsValue({
        name: infoAccount?.fullname,
        email: infoAccount?.email,
        nationwideId: infoAccount?.nationwideId,
        regionId: infoAccount?.regionId,
        unitId: infoAccount?.unit?.id,
        businessUnitId: infoAccount?.businessUnitId,
        departmentId: infoAccount?.departmentId,
        permission: permissionTmp,
      });

    } else {
      form.resetFields();
      setValuesUnitList([]);
      setUnitCounts([]);
      setCheckloading(false);
      setHasInitFirstScope(false);
    }
  }, [isOpen]);

  // useEffect(() => {
  //   if (unitId === undefined || unitId === null) return;
  //   if (hasInitFirstScope) return;

  //   const currentPermissions = form.getFieldValue('permission') || [];

  //   const updatedPermissions = [...currentPermissions];

  //   updatedPermissions[0] = {
  //     ...updatedPermissions[0],
  //     scopeofoperation: [unitId],
  //   };

  //   form.setFieldsValue({
  //     permission: updatedPermissions,
  //   });

  //   setValuesUnitList((prev) => {
  //     const next = [...prev];
  //     next[0] = [unitId];
  //     return next;
  //   });

  //   setHasInitFirstScope(true);
  // }, [unitId, hasInitFirstScope, form]);
  useEffect(() => {
    if (infoAccount?.unit) return
    if (unitId === undefined || unitId === null) return;
    if (!dataListNationwide.length) return;
    if (hasInitFirstScope) return;

    const scopeIds = getSelfAndChildIdsByParentId(
      dataListNationwide,
      Number(unitId)
    );

    const currentPermissions = form.getFieldValue('permission') || [];

    const updatedPermissions = [...currentPermissions];

    updatedPermissions[0] = {
      ...updatedPermissions[0],
      scopeofoperation: scopeIds,
    };

    form.setFieldsValue({
      permission: updatedPermissions,
    });

    setValuesUnitList((prev) => {
      const next = [...prev];
      next[0] = scopeIds;
      return next;
    });

    // setUnitCounts((prev) => {
    //   const next = [...prev];
    //   next[0] = scopeIds.length;
    //   return next;
    // });

    setHasInitFirstScope(true);
  }, [unitId, dataListNationwide, hasInitFirstScope, form]);
  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Drawer
        title={<p className="custom-page-css font-medium fw-500 text-344054  pl-3 pt-3 pb-3 bg-FCFCFD">Chỉnh sửa người dùng mới</p>}
        placement="right"
        rootClassName="custom-drawer-v2"
        closable={false}
        onClose={closeDrawer}
        open={isOpen}
        footer={<div className="py-2 px-6 bg-FCFCFD d-flex justify-between gap-2">
          <button
            className="border-EDEDEE bg-white rounded-2  h-8  text-sm font-regular text-344054 px-2"
            onClick={closeDrawer}
          >
            Hủy
          </button>
          <button
            disabled={checkloading}
            onClick={submitForm}
            className="border-none bg-096DD9 rounded-2  h-8  text-sm font-regular text-white px-2">
            Cập nhật
          </button>
        </div>}
      >
        <LoadingSpin
          checkLoading={checkloading}
        />

        <div className="d-flex flex-column ">
          {/* <p className="text-sm fw-700 font-bold text-344054 py-4">Thông tin cơ bản</p> */}
          <div className="d-flex flex-column gap-3">
            <div className="d-flex flex-column gap-3">
              <p className=" text-sm fw-500 font-medium text-475467 ">Mã nhân viên</p>
              <Input
                placeholder="Mã đơn vị"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-10"
                value={infoAccount?.code}
                disabled
              />
            </div>
            <div className="d-flex flex-column gap-3">
              <p className=" text-sm fw-500 font-medium text-475467 ">Họ và tên</p>
              <Form.Item
                name="name"
                className="m-none-form-item text-explan"
              >
                <Input
                  disabled
                  placeholder="Họ và tên"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-10"
                />
              </Form.Item>

            </div>
          </div>

          {/* <p className="text-sm fw-700 font-bold text-344054 py-5">Quyền và nhóm quyền</p> */}
          <div className="d-flex flex-column gap-3 pt-3">
            <div className="d-flex flex-column gap-1">
              <p className="text-sm  font-regular text-344054">Chọn đơn vị</p>
              <Form.Item
                name="unitId"
                rules={[{ required: true, message: 'Chọn đơn vị!' }]}
                className="m-none-form-item text-explan"
              >
                <TreeSelect
                  showSearch
                  placeholder="Chọn đơn vị"
                  allowClear
                  treeDefaultExpandAll={false}
                  treeData={sLUnitByPermission}
                  className="custom-tree-select "
                  filterTreeNode={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                />
              </Form.Item>
            </div>
            <div className="d-flex flex-column gap-3">
              <Form.List
                name="permission"
                initialValue={[{}]}
              >
                {(fields, { add, remove }) => (
                  <div className='d-flex flex-column gap-3'>
                    {fields.map((field, i) => (
                      <div key={field.key} className="d-flex gap-3  ">
                        <img
                          src={icon_delelte}
                          alt=""
                          className="rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"
                          onClick={() => {
                            remove(i);
                            setValuesUnitList((prev) => {
                              const newList = [...prev];
                              newList.splice(i, 1);
                              return newList;
                            });
                            setSelectedIds(prev => {
                              const newIds = [...prev];
                              newIds.splice(i, 1);
                              return newIds;
                            });
                          }}
                        />
                        <Form.Item
                          name={[field.name, 'grouppermission']}
                          className="m-none-form-item text-explan w-40-percent overflow-hidden"
                          rules={[{ required: true, message: 'Chọn nhóm quyền!' }]}
                        >
                          <Select
                            placeholder="Chọn nhóm quyền"
                            className="custome-select-t "

                            allowClear
                            options={
                              fommatSelectOption(
                                sLGroupPermission.filter(item => !selectedIds.includes(item.id) || i === selectedIds.indexOf(item.id)
                                )
                              )
                            }
                            onChange={(value) => handleGroupPermission(i, value)}
                          />
                        </Form.Item>
                        <div className="relative w-60-percent div-children-full h-full overflow-hidden">
                          <Form.Item
                            name={[field.name, 'scopeofoperation']}
                            className="m-none-form-item text-explan h-full w-full custom-css-select"
                            rules={[{ required: true, message: 'Chọn phạm vi hoạt động!' }]}
                          >

                            <TreeSelectCustom_V2
                              className="h-full w-full"
                              data={dataListNationwide}
                              // value={selectedIds}                              // ví dụ: [101, 205]
                              value={valuesUnitList[i] || []}
                              onChange={(ids) => handleChangeUnit(i, ids)}    // nhận về [number, ...]
                              disabledIds={getDisabledIdsForIndex(i)}                              // khoá node có value=244 (và cả subtree nếu cascadeDisable=true)
                              cascadeDisable={true}
                              disableMode="disabled"                           // hoặc "disableCheckbox" nếu chỉ muốn khoá tick
                            />

                          </Form.Item>
                          {(valuesUnitList[i]?.length ?? 0) > 0 && (
                            <p className="bg-F0F5FF border-ADC6FF rounded-2 text-2F54EB text-sm px-2 d-flex align-center gap-3-px h-auto font-regular justify-between absolute custom-css-count-select">
                              {/* {unitCounts[i] || valuesUnitList[i].length} đơn vị được chọn */}
                              {valuesUnitList[i].length} đơn vị được chọn
                            </p>
                          )}

                        </div>


                      </div>
                    ))}

                    <button
                      className='border-dashed-1890FF bg-white rounded-6-px  py-2 h-8 d-flex justify-center align-center gap-2 w-full'
                      onClick={() => {
                        const targetUnitId = infoAccount?.unit?.id || unitId;
                        const allScope = targetUnitId ? getSelfAndChildIdsByParentId(dataListNationwide, Number(targetUnitId)) : [];
                        const usedIds = valuesUnitList.flat();
                        const defaultScope = allScope.filter(id => !usedIds.includes(id));
                        add({ grouppermission: undefined, scopeofoperation: defaultScope });
                        setValuesUnitList((prev) => [...prev, defaultScope]);
                        // setUnitCounts((prev) => [...prev, 0]);
                      }}

                    >
                      <PlusOutlined className='text-sm text-1890FF' />
                      <span className='text-sm fw-400 font-regular text-1890FF white-space-nowrap'>Thêm nhóm quyền</span>
                    </button>

                  </div>
                )}
              </Form.List>
            </div>
          </div>
        </div>
      </Drawer>
    </Form >

  )
}
export default EditAccount_V3
